import { useState, useRef, useEffect } from "react";
import MapComponent from "./MapComponent";
import Delete from "/Delete1.png?url";

import Map from "/map.png?url";

import { Bar } from "react-chartjs-2";
import axios from "axios";

import L from "leaflet";

function EditBranchModal({ branch, closeModal, updateBranchSuccess }) {
  const [branchName, setBranchName] = useState(branch.name);
  const [branchCode, setBranchCode] = useState(branch.code);
  const [location, setLocation] = useState(branch.location || "");
  const [lat, setLat] = useState(branch.lat || "");
  const [lng, setLng] = useState(branch.lng || "");
  const [showMap, setShowMap] = useState(false);

  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [isLightActive, setIsLightActive] = useState(
    branch.schedule_light_bulbs_active
  );

  const [timeInputs, setTimeInputs] = useState([]);

  useEffect(() => {
    if (branch.schedule_light_bulbs) {
      const initialTimeInputs = branch.schedule_light_bulbs
        .filter((bulb) => bulb.period !== null && bulb.brightness !== null) // Filter out null values
        .map((bulb, index) => ({
          id: index + 1,
          timeValue: bulb.period || "", // Set to "" if period is null
          rangeValue: bulb.brightness !== null ? bulb.brightness : 0, // Set to 0 if brightness is null
        }));
      setTimeInputs(initialTimeInputs);
    }
  }, [branch.schedule_light_bulbs]);

  const handleTimeChange = (id, value) => {
    setTimeInputs(
      timeInputs.map((input) =>
        input.id === id ? { ...input, timeValue: value } : input
      )
    );
  };

  const handleRangeChange = (id, value) => {
    setTimeInputs(
      timeInputs.map((input) =>
        input.id === id ? { ...input, rangeValue: value } : input
      )
    );
  };

  const handleRemoveTimeInput = (id) => {
    setTimeInputs(timeInputs.filter((input) => input.id !== id));
  };

  function timeToMinutes(timeValue) {
    const [hours, minutes] = timeValue.split(":").map(Number);
    return hours * 60 + minutes;
  }

  const sortedTimeInputs = [...timeInputs].sort((a, b) => {
    const timeA = a.timeValue ? timeToMinutes(a.timeValue) : Infinity;
    const timeB = b.timeValue ? timeToMinutes(b.timeValue) : Infinity;
    return timeA - timeB;
  });

  function minutesToTime(minutes) {
    if (minutes < 0) {
      minutes = 23 * 60 + 59;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
  }

  const labels = sortedTimeInputs.map((input, index) => {
    if (index < sortedTimeInputs.length - 1) {
      const nextTimeInMinutes =
        timeToMinutes(sortedTimeInputs[index + 1].timeValue) - 1;
      const adjustedNextTime = minutesToTime(nextTimeInMinutes);
      return `${input.timeValue} - ${adjustedNextTime}`;
    } else {
      const firstTimeInMinutes =
        timeToMinutes(sortedTimeInputs[0].timeValue) - 1;
      const adjustedFirstTime = minutesToTime(firstTimeInMinutes);
      return `${input.timeValue} - ${adjustedFirstTime}`;
    }
  });

  const chartData = {
    labels,
    datasets: [
      {
        data: sortedTimeInputs.map((input) => input.rangeValue),
        backgroundColor: "#F5B81C",
      },
    ],
  };

  const options = {
    scales: {
      x: {
        ticks: {
          color: "white",
        },
        grid: {
          color: "transparent",
        },
      },
      y: {
        position: "right",
        beginAtZero: true,
        ticks: {
          color: "white",
          callback: function (value) {
            return value + "%";
          },
        },
        min: 0,
        max: 100,
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  const handleToggleChange = (event) => {
    setIsActive(event.target.checked);
  };

  const [isActive, setIsActive] = useState(branch.active);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!branchName || !branchCode) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return;
    }

    const branchData = {
      name: branchName,
      code: branchCode,
      location: location,
      lat: lat,
      lng: lng,
      schedule_light_bulbs_active: isLightActive,
      active: isActive,
      schedule_light_bulbs: timeInputs.map((input) => ({
        period: input.timeValue,
        brightness: input.rangeValue,
      })),
    };

    try {
      const response = await axios.put(
        `${import.meta.env.VITE_API_URL}/branches/${branch.id}`,
        branchData
      );
      console.log("Branch updated successfully:", response.data);
      updateBranchSuccess(response.data);
      closeModal();
    } catch (error) {
      console.error("Error updating branch:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดตข้อมูลสาขา");
    }
  };

  const handleAddTimeClick = (event) => {
    event.preventDefault();
    const newInput = {
      id: Date.now(),
      rangeValue: 0,
      timeValue: "", // Placeholder for the time input by the user
    };
    setTimeInputs(timeInputs.concat(newInput));
  };

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true
  ) => (
    <div className="float-label-container">
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className="input-required"
        required={required}
        placeholder=" "
      />
      <label htmlFor={id}>
        {label} {required && <span className="required-asterisk"> *</span>}
      </label>
    </div>
  );

  const handleLocationSelect = (selectedData) => {
    setLocation(selectedData.location);
    setLat(selectedData.lat);
    setLng(selectedData.lng);
  };

  const [showMapButton, setShowMapButton] = useState(true);
  const [useCurrentLocation, setUseCurrentLocation] = useState(false);

  const handleUseCurrentLocationChange = (event) => {
    const isChecked = event.target.checked;
    setUseCurrentLocation(isChecked);
    if (isChecked) {
      getCurrentLocation();
    } else {
      setLocation("");
      setLat("");
      setLng("");
    }
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLat(latitude.toFixed(6));
          setLng(longitude.toFixed(6));

          try {
            const response = await axios.get(
              `https://nominatim.openstreetmap.org/reverse`,
              {
                params: {
                  lat: latitude,
                  lon: longitude,
                  format: "json",
                },
              }
            );
            setLocation(response.data.display_name);

            if (mapRef.current) {
              mapRef.current.setView([latitude, longitude], 13);
              let marker = markerRef.current;
              if (marker) {
                marker.setLatLng([latitude, longitude]);
              } else {
                marker = L.marker([latitude, longitude], {
                  draggable: true,
                }).addTo(mapRef.current);
                markerRef.current = marker;
              }
            }
          } catch (error) {
            console.error("Error fetching address from coordinates:", error);
          }
        },
        (error) => {
          console.error("Error getting current location:", error);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    if (useCurrentLocation) {
      getCurrentLocation();
    }
  }, [useCurrentLocation]);

  useEffect(() => {
    if (location === "" && lat === "" && lng === "") {
      setShowMapButton(true);
    } else {
      setShowMapButton(false);
    }
  }, [location, lat, lng]);

  const handleToggleLightChange = () => {
    setIsLightActive(!isLightActive);
  };

  const handleCloseMap = () => {
    setShowMap(false);
  };

  return (
    <div className="BranchModal">
      <div className="BranchModalContent">
        <button className="close-button" onClick={closeModal}>
          &times;
        </button>

        <h3>แก้ไขข้อมูลสาขา</h3>
        <form onSubmit={handleSubmit} className="edit-branch-form">
          <strong>ข้อมูลสาขา</strong>
          <div className="form-content">
            {renderFloatLabelInput(
              "ชื่อสาขา",
              "text",
              "branchName",
              "branchNameInput",
              branchName,
              (e) => setBranchName(e.target.value)
            )}
            {renderFloatLabelInput(
              "รหัสสาขา",
              "text",
              "branchCode",
              "branchCodeInput",
              branchCode,
              (e) => setBranchCode(e.target.value)
            )}
            <div className="relativMap">
              {renderFloatLabelInput(
                "สถานที่ตั้ง",
                "text",
                "location",
                "location",
                location,
                (e) => setLocation(e.target.value)
              )}

              {showMapButton && (
                <img
                  src={Map}
                  alt="เลือกจากแผนที่"
                  onClick={() => setShowMap(!showMap)}
                />
              )}
              <div className="up2">
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="useCurrentLocation"
                    checked={useCurrentLocation}
                    onChange={handleUseCurrentLocationChange}
                  />
                  <label
                    htmlFor="useCurrentLocation"
                    className="label-useCurrentLocation"
                  >
                    ใช้ตำแหน่งปัจจุบัน
                  </label>
                </div>
              </div>
            </div>

            {renderFloatLabelInput(
              "ละติจูด",
              "text",
              "lat",
              "lat",
              lat,
              (e) => setLat(e.target.value),
              true
            )}
            {renderFloatLabelInput(
              "ลองจิจูด",
              "text",
              "lng",
              "lng",
              lng,
              (e) => setLng(e.target.value),
              true
            )}
          </div>

          <div className="form-content2">
            <div className="toggle-switch-container">
              <span>{isActive ? "เปิด" : "ปิด"}การใช้งานสาขา</span>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={handleToggleChange}
                />
                <span className="slider"></span>
              </label>
            </div>
            <label>ปรับความสว่างหลอดไฟแบบอัตโนมัติ (ค่าเริ่มต้น)</label>
            <div className="toggle-switch-container">
              <span>{isLightActive ? "ทำงานปกติ" : "หยุดทำงาน"}</span>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isLightActive}
                  onChange={handleToggleLightChange}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="add-time">
              <div className="add-time-button-container">
                <button
                  className="add-time-button"
                  onClick={handleAddTimeClick}
                >
                  + เพิ่มเวลา
                </button>
              </div>
            </div>
          </div>
        </form>

        {timeInputs.length > 0 && (
          <div>
            {[...timeInputs]
              .sort((a, b) => {
                const timeA = a.timeValue
                  ? timeToMinutes(a.timeValue)
                  : Infinity;
                const timeB = b.timeValue
                  ? timeToMinutes(b.timeValue)
                  : Infinity;
                return timeA - timeB;
              })
              .map((input, index) => (
                <div key={input.id} className="time-input-container">
                  <label>เวลา</label>
                  <input
                    type="time"
                    className="time-display1"
                    value={input.timeValue}
                    onChange={(e) => handleTimeChange(input.id, e.target.value)}
                  />
                  <div
                    className="slider-container"
                    style={{ position: "relative" }}
                  >
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value={input.rangeValue}
                      className="gradient-range"
                      onChange={(e) =>
                        handleRangeChange(input.id, e.target.value)
                      }
                    />
                    <div
                      className="value-display"
                      style={{
                        left: `calc(${input.rangeValue}% + 10px)`,
                        transform: "translateX(-50%)",
                        bottom: "-15px",
                      }}
                    >
                      {input.rangeValue}%
                    </div>
                  </div>
                  <button
                    className="delete-button"
                    onClick={() => handleRemoveTimeInput(input.id)}
                  >
                    <img src={Delete} alt="Delete" />
                  </button>
                </div>
              ))}
            {timeInputs.some((input) => input.timeValue) && (
              <div className="setlight chartContainer">
                <Bar data={chartData} options={options} />
              </div>
            )}
          </div>
        )}

        <div className="button-adduser-detali">
          <button className="cancel-button" onClick={closeModal}>
            ยกเลิก
          </button>
          <button className="confirm-button" onClick={handleSubmit}>
            บันทึก
          </button>
        </div>
      </div>

      {showMap && (
        <MapComponent
          onLocationSelect={handleLocationSelect}
          onClose={handleCloseMap}
        />
      )}
    </div>
  );
}

export default EditBranchModal;
